<script>
	export default {
		name: 'LanguageExecuter',
		methods: {
			switchLanguage(language) {
				const self_ = this;

				const languages_ = self_.getAppContents('languages')
				const cookie_ = self_.getCookie('language')

				let key_ = null;
				// switch to default language
				if(self_.isFalse(language) && self_.isFalse(cookie_)) { 
					const default_ = self_.findObject(languages_, 'isDefault', true)
					key_ = default_.key;
				}
				// switch to language in cookie
				else if(self_.isFalse(language)) {
					key_ = cookie_;
				}
				// switch to target language
				else {
					key_ = language;
				}	

				self_.setAppState('language', key_)
				self_.setCookie('language', key_)
			}
		}
	}
</script>